import {
    NinchatActionType,
    NinchatDescribeIdentityAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const describeIdentity = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatDescribeIdentityAction}`,
    async (arg: NinchatActionParams<NinchatDescribeIdentityAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatDescribeIdentityAction

        try {
            return await ninchatClient.send(params)
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
